import FormHelperText from "@material-ui/core/FormHelperText";
export default FormHelperText;

export let styles = theme => ({
  root: {
    marginTop: "6px",
    lineHeight: "1rem"
  },
  contained: {
    margin: "6px 4px 0"
  }
});
